import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryOrderList extends BaseModelAPI {

	static entity = 'deliveryorderlist'
	static entityName = 'deliveryorder';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
